// Usage meter (PR 2): the plan-minutes bar and the monthly usage report, shared by the
// user's Settings → Plan and the admin user page's Usage box.

import type { UsageLevel, UsageMonth } from '../api';
import { callsText, leftText, meterTone, percentUsed, planMinutesText, usedText } from '../usage-text';

export function UsageBar({ used, bundle, left, level, resetText }: { used: number; bundle: number; left: number; level: UsageLevel; resetText: string | null }) {
  const pct = percentUsed(used, bundle);
  return (
    <div className={`usage-meter usage-${meterTone(level)}`} data-usage-level={level}>
      <div className="usage-line">
        <strong>{usedText(used, bundle)}</strong>
        {resetText && <span className="usage-reset">resets {resetText}</span>}
      </div>
      <div
        className="usage-track"
        role="progressbar"
        aria-label="Plan minutes used"
        aria-valuemin={0}
        aria-valuemax={bundle}
        aria-valuenow={Math.min(used, bundle)}
        aria-valuetext={`${usedText(used, bundle)}, ${leftText(left)}`}
      >
        <span className="usage-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="usage-left">{leftText(left)}</span>
    </div>
  );
}

export function UsageReport({ months, caption }: { months: UsageMonth[]; caption: string }) {
  if (!months.length) return null;
  return (
    <div className="usage-report-wrap">
      <table className="usage-report">
        <caption>{caption}</caption>
        <thead>
          <tr>
            <th scope="col">Month</th>
            <th scope="col">Plan minutes</th>
            <th scope="col">Calls out</th>
            <th scope="col">Calls in</th>
          </tr>
        </thead>
        <tbody>
          {months.map((m) => (
            <tr key={m.from} className={m.current ? 'usage-now' : undefined}>
              <th scope="row">
                {m.title}
                {m.current && <span className="usage-so-far"> (so far)</span>}
              </th>
              <td>{planMinutesText(m)}</td>
              <td>{callsText(m.callsOut, m.minutesOut)}</td>
              <td>{callsText(m.callsIn, m.minutesIn)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
